import {
   GET_ALL_DASHBOARD_WHATS_NEW,
   GET_ROJMEL,
   GET_TOTAL_SALES_AND_PURCHASES,
   GET_TOP_FIVE_PARTY_WISE_PURCHASE,
   GET_TOP_FIVE_PARTY_WISE_SALES,
   GET_MONTHLY_SALES_SUMMARY,
   GET_MONTHLY_PURCHASE_SUMMARY,
   GET_QUARTERLY_SALES_SUMMARY,
   GET_QUARTERLY_PURCHASE_SUMMARY,
   GET_GROWTH_RATE,
   GET_DAY_OF_WEEK_PERFORMANCE,
   GET_TOP_TO_BOTTOM_PERFORMANCE,
   GET_MOVING_AVERAGE_TRENDS,
   GET_PROFITABILITY_ANALYSIS_BY_CUSTOMER,
   GET_CASH_FLOW_ANALYSIS,
   GET_TRANSACTION_SIZE_DISTRIBUTION_ANALYSIS,
   GET_AGING_ANALYSIS,
   GET_HEATMAP_DATA,
   GET_YEAR_OVER_YEAR_COMPARISON,
   GET_CUSTOMER_CONCENTRATION_ANALYSIS,
   GET_WEEKLY_PERFORMANCE_TRENDS,
   GET_CITY_WISE_SALES,
   GET_EXCEPTION_REPORTING,
   GET_MONTHLY_CUSTOMER_SALES,
   GET_CUSTOMER_SALES_VALUE,
   GET_FINANCIAL_YEARS,
   GET_CASH_AND_BANK_BALANCE,
   GET_RECEIVE_AND_PAY,
   GET_SALES_PAYMENT_RECEIVE_REPORT,
   GET_PURCHASE_PAID_REPORT,
   GET_LAST_FIVE_YEAR_SALES_COMPARISON_REPORT,
   GET_LAST_FIVE_YEAR_PURCHASE_COMPARISON_REPORT,
   SALES_PURCHASES_OVERVIEW,
   GET_BARCODE_DATA,
   GET_BALANCE,
} from '../types';

const initialState = {
   list: [],
   single: null,
   totalCount: 0,
   ledger: [],
   rojmelList: [],
   totalSalesAndPurchases: [],
   topFivePartyWisePurchase: [],
   topFivePartyWiseSales: [],
   monthlySalesSummary: [],
   monthlyPurchaseSummary: [],
   quarterlySalesSummary: [],
   quarterlyPurchaseSummary: [],
   growthRate: [],
   dayOfWeekPerformance: [],
   topToBottomPerformance: [],
   movingAverageTrends: [],
   profitabilityAnalysisByCustomer: [],
   cashFlowAnalysis: [],
   transactionSizeDistributionAnalysis: [],
   agingAnalysis: [],
   heatmapData: [],
   yearOverYearComparison: [],
   customerConcentrationAnalysis: [],
   weeklyPerformanceTrends: [],
   cityWiseSales: [],
   exceptionReporting: [],
   monthlyCustomerSales: [],
   customerSalesValue: [],
   financialYears: [],
   cashAndBankBalance: [],
   receiveAndPay: [],
   salesPaymentReceiveReport: [],
   purchasePaidReport: [],
   lastFiveYearSalesComparisonReport: [],
   lastFiveYearPurchaseComparisonReport: [],
};

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_ALL_DASHBOARD_WHATS_NEW:
         return { ...state, list: payload };
      case GET_ROJMEL:
         return { ...state, rojmelList: payload };

      case GET_TOTAL_SALES_AND_PURCHASES:
         return { ...state, totalSalesAndPurchases: payload };

      case GET_TOP_FIVE_PARTY_WISE_PURCHASE:
         return { ...state, topFivePartyWisePurchase: payload };

      case GET_TOP_FIVE_PARTY_WISE_SALES:
         return { ...state, topFivePartyWiseSales: payload };

      case GET_MONTHLY_SALES_SUMMARY:
         return { ...state, monthlySalesSummary: payload };

      case GET_MONTHLY_PURCHASE_SUMMARY:
         return { ...state, monthlyPurchaseSummary: payload };

      case GET_QUARTERLY_SALES_SUMMARY:
         return { ...state, quarterlySalesSummary: payload };

      case GET_QUARTERLY_PURCHASE_SUMMARY:
         return { ...state, quarterlyPurchaseSummary: payload };

      case GET_GROWTH_RATE:
         return { ...state, growthRate: payload };

      case GET_DAY_OF_WEEK_PERFORMANCE:
         return { ...state, dayOfWeekPerformance: payload };

      case GET_TOP_TO_BOTTOM_PERFORMANCE:
         return { ...state, topToBottomPerformance: payload };

      case GET_MOVING_AVERAGE_TRENDS:
         return { ...state, movingAverageTrends: payload };

      case GET_PROFITABILITY_ANALYSIS_BY_CUSTOMER:
         return { ...state, profitabilityAnalysisByCustomer: payload };

      case GET_CASH_FLOW_ANALYSIS:
         return { ...state, cashFlowAnalysis: payload };

      case GET_TRANSACTION_SIZE_DISTRIBUTION_ANALYSIS:
         return { ...state, transactionSizeDistributionAnalysis: payload };

      case GET_AGING_ANALYSIS:
         return { ...state, agingAnalysis: payload };

      case GET_HEATMAP_DATA:
         return { ...state, heatmapData: payload };

      case GET_YEAR_OVER_YEAR_COMPARISON:
         return { ...state, yearOverYearComparison: payload };

      case GET_CUSTOMER_CONCENTRATION_ANALYSIS:
         return { ...state, customerConcentrationAnalysis: payload };

      case GET_WEEKLY_PERFORMANCE_TRENDS:
         return { ...state, weeklyPerformanceTrends: payload };

      case GET_CITY_WISE_SALES:
         return { ...state, cityWiseSales: payload };

      case GET_EXCEPTION_REPORTING:
         return { ...state, exceptionReporting: payload };

      case GET_MONTHLY_CUSTOMER_SALES:
         return { ...state, monthlyCustomerSales: payload };

      case GET_CUSTOMER_SALES_VALUE:
         return { ...state, customerSalesValue: payload };

      case GET_FINANCIAL_YEARS:
         return { ...state, financialYears: payload };

      case GET_CASH_AND_BANK_BALANCE:
         return { ...state, cashAndBankBalance: payload };

      case GET_RECEIVE_AND_PAY:
         return { ...state, receiveAndPay: payload };

      case GET_SALES_PAYMENT_RECEIVE_REPORT:
         return { ...state, salesPaymentReceiveReport: payload };

      case GET_PURCHASE_PAID_REPORT:
         return { ...state, purchasePaidReport: payload };

      case GET_LAST_FIVE_YEAR_SALES_COMPARISON_REPORT:
         return { ...state, lastFiveYearSalesComparisonReport: payload };

      case GET_LAST_FIVE_YEAR_PURCHASE_COMPARISON_REPORT:
         return { ...state, lastFiveYearPurchaseComparisonReport: payload };

      case SALES_PURCHASES_OVERVIEW:
         return { ...state, salesPurchaseOverview: payload };

      case GET_BARCODE_DATA:
         return { ...state, barcodeData: payload };

      case GET_BALANCE:
         console.log('Reducer - GET_BALANCE payload:', payload);
         console.log('Reducer - payload keys:', payload ? Object.keys(payload) : 'No payload');
         return { ...state, balanceData: payload };

      default:
         return state;
   }
};

export default reducer;
